import React, { ReactNode } from 'react';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import SomethingWentWrong from 'components/Shared/ErrorPageView/SomethingWentWrong';

type TErrorBoundaryProps = {
  children: ReactNode;
};

const renderFallback = ({
  error,
  componentStack,
  resetError,
}: {
  error: Error;
  componentStack?: string;
  resetError: () => void;
}) => (
  <SomethingWentWrong
    error={error}
    componentStack={componentStack}
    onReset={resetError}
  />
);

const ErrorBoundary = ({ children }: TErrorBoundaryProps) => {
  return (
    <SentryErrorBoundary
      fallback={renderFallback}
      onError={(error, componentStack) => {
        // eslint-disable-next-line no-console
        console.error('ErrorBoundary caught:', error, componentStack);
      }}
    >
      {children}
    </SentryErrorBoundary>
  );
};

export default ErrorBoundary;
